
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section 
      className="relative py-24 px-6 lg:px-8 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.3)), url('https://public.readdy.ai/ai/img_res/efc338e21a0f8600a6d01ef84df5f9a6.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl">
          <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: '"Libre Baskerville", serif' }}>
            Discover the Soul of 
            <span className="text-red-400"> Canadian Literature</span>
          </h1>
          <p className="text-xl text-gray-200 mb-8 leading-relaxed">
            From coast to coast to coast, we celebrate the diverse voices that make Canadian literature extraordinary. We review and highlight literary works released by major publishing houses, independent publishing houses and self-published authors. As long as you're Canadian we'll review and highlight your work. Explore our recent reviews and interviews that capture the essence of our nation's storytelling tradition.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/reviews">
              <Button size="lg" className="w-full sm:w-auto">
                <i className="ri-book-open-line mr-2"></i>
                Explore Reviews
              </Button>
            </Link>
            <Link to="/submit">
              <Button variant="outline" size="lg" className="w-full sm:w-auto bg-white/10 border-white text-white hover:bg-white hover:text-gray-900">
                <i className="ri-quill-pen-line mr-2"></i>
                Submit Your Work
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
